var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import './CycleBar.css';
import { CycleDots_ } from './Dot/CycleDots_';
import { CycleBarPreviousButton } from './NextPrevious/CycleBarPreviousButton';
import { CycleBarNextButton } from './NextPrevious/CycleBarNextButton';
import { CycleBarCountdownButton } from './Countdown/CycleBarCountdownButton';
import { CycleBarCountdownTime } from './Countdown/CycleBarCountdownTime';
import { CycleBarPreload } from './CycleBarPreload';
let CycleBar = class CycleBar extends React.PureComponent {
    get leftContent() {
        const { app } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement(CycleBarPreviousButton, { app: app })));
    }
    get centerContent() {
        const { app } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { style: {
                    flex: '1 1 auto',
                    maxWidth: 400,
                    minWidth: 100,
                    display: 'flex',
                    alignItems: 'center',
                } },
                React.createElement("div", { style: {
                        flex: '1 1 auto',
                        height: 15,
                        display: 'flex',
                        alignItems: 'stretch',
                        justifyContent: 'stretch',
                    } },
                    React.createElement(CycleDots_, { app: app }))),
            React.createElement(CycleBarCountdownButton, { app: app }),
            React.createElement(CycleBarCountdownTime, { app: app })));
    }
    get rightContent() {
        const { app } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement(CycleBarNextButton, { app: app })));
    }
    render() {
        const { app } = this.props;
        if (!app.tray.trayCycles.areCyclesAvailable) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(CycleBarPreload, { app: app }),
            React.createElement("div", { style: {
                    flex: '0 1 auto',
                    display: 'flex',
                    flexWrap: 'nowrap',
                } }, this.leftContent),
            React.createElement("div", { style: { flex: '1 1 auto', display: 'flex', justifyContent: 'center', alignItems: 'stretch', fontSize: 20 } }, this.centerContent),
            React.createElement("div", { style: {
                    flex: '0 1 auto',
                    display: 'flex',
                    flexWrap: 'nowrap',
                } }, this.rightContent)));
    }
};
CycleBar = __decorate([
    observer
], CycleBar);
export { CycleBar };
